import VirtualSeller_QSet from './roleQuestionSets/VirtualSeller';
import SalesManager_QSet from './roleQuestionSets/SalesManager';
import SalesExecutive_QSet from './roleQuestionSets/SalesExecutive';
import DigitalEcommerce_QSet from './roleQuestionSets/DigitalEcommerce';
import SalesMidOffice_QSet from './roleQuestionSets/SalesMidOffice';
import RevenueManagement_QSet from './roleQuestionSets/RevenueManagement';
import None from './roleQuestionSets/RevenueManagement';

const QuestionSets = {
    'Select your functional area': None,
    'Virtual Seller': VirtualSeller_QSet,
    'Sales Manager': SalesManager_QSet,
    'Sales Executive': SalesExecutive_QSet,
    'Head of Digital and Ecommerce': DigitalEcommerce_QSet,
    'CPQ and Sales Operations': SalesMidOffice_QSet,
    'Revenue Management': RevenueManagement_QSet,
};       

export default QuestionSets;
